import classNames from "classnames";

interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  cover?: boolean;
  fullscreen?: boolean;
  backdrop?: boolean;
}

function Spinner(props: SpinnerProps) {
  const spinnerClassNames = classNames(
    "gds-spinner",
    {
      "gds-spinner-sm": props.size === "sm",
      "gds-spinner-lg": props.size === "lg",
      "gds-spinner-cover": props.cover,
      "gds-spinner-fullscreen": props.fullscreen,
      "gds-spinner-backdrop": props.backdrop,
    },
    props.className
  );

  return <div data-testid="spinner__testid" className={spinnerClassNames} role="status" aria-live="assertive"></div>;
}

export default Spinner;
